import { BASE } from './api.js';

export interface EstudioEnviado {
  readonly id: string;
  readonly titulo: string;
  readonly editor: string;
  readonly url: string;
  readonly bytes: number;
  readonly creadoEn: string;
  readonly estado: 'enviado' | 'aprobado' | 'rechazado' | 'retirado';
  readonly motivo: string | null;
  readonly estadoIngesta: null | 'en_cola' | 'procesando' | 'revision_tecnica' | 'error' | 'incorporado' | 'cargado';
  readonly fuenteSlug: string | null;
  readonly propietarioId?: string;
  readonly email?: string;
  readonly duplicado?: boolean;
}

export interface PermisoEditor {
  readonly id: string;
  readonly email: string;
  readonly puedeEnviarEstudios: boolean;
  readonly entidad: string;
  readonly nota: string;
}

export interface ConfigEstudios {
  readonly maxBytes: number;
  readonly limitePendientes: number;
}
export type ResultadoEstudios<T> = { readonly ok: true; readonly datos: T } | { readonly ok: false; readonly status: number };

/** Token capturado por la pantalla: una respuesta tardía nunca adopta otra identidad. */
export async function pedirEstudios<T>(token: string, ruta: string, method = 'GET', body?: FormData | object): Promise<ResultadoEstudios<T>> {
  try {
    const multipart = body instanceof FormData;
    const r = await fetch(`${BASE}/estudios${ruta}`, {
      method,
      headers: { authorization: `Bearer ${token}`, ...(!multipart && body ? { 'content-type': 'application/json' } : {}) },
      ...(body ? { body: multipart ? body : JSON.stringify(body) } : {}),
    });
    if (!r.ok) return { ok: false, status: r.status };
    return { ok: true, datos: (r.status === 204 ? null : await r.json()) as T };
  } catch {
    return { ok: false, status: 0 };
  }
}
